<template>
    <div>
        <iframe frameBorder="0" src="https://docs.google.com/presentation/d/1tJ3p1mrTE05biYCXYRplm3v5mEEZ-htpuHK3o-XW88E/embed?start=true&loop=true&delayms=10000&rm=minimal"></iframe>
    </div>
</template>

<script>
    export default {};
</script>

<style scoped lang="scss">
    iframe {
        border: none;
        width: 100%;
        height: 100%;
    }
</style>
